import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Grid,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const CaliforniaFormRRF = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="California Form RRF-1 Instructions & Filing Requirements"
          description="California Form RRF-1 filing guide covering instructions, due dates, fees, filing requirements, required attachments, and compliance rules for nonprofits"
          keywords=""
          canonical="resources/tax-exempt/ca-form-rrf1-filing-guide/"
          ogType="article"
          jsonLdPricing="89.99"
          jsonLdAggregateRatingValue="4.99"
          jsonLdAggregateRatingCount="2063"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          {' '}
          <span className="highlight-container">
            <span className="highlight">Form RRF-1</span>
          </span>{' '}
          – Annual Registration Renewal Fee Report (California Nonprofit Guide)
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          Discover the differences in 990 forms which suit your organization’s
          need—with TaxZerone!
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=990vs990EZ`}
          >
            E-file Now!
          </Button>
        </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/tax-exempt/ca-form-rrf1-filing-guide/"
                  />

                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>

                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-07-20T09:00:00-05:00"
                      >
                        July 20, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-07-20T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        July 20, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Peter Samuel
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>

                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    CA Form RRF-1 at a Glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',

                      '& li': {
                        mb: 1.6,
                        position: 'relative',
                        pl: 3,
                      },

                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          Purpose: Form RRF-1 (Annual Registration Renewal Fee
                          Report)
                        </strong>{' '}
                        is used by qualifying California charitable
                        organizations to{' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          renew their registration and report annual financial
                          information
                        </strong>
                        to the Attorney General's Registry of Charities and
                        Fundraisers.
                      </span>
                    </li>

                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          Who Must File?
                        </strong>{' '}
                        Charitable{' '}
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          nonprofit corporations, unincorporated associations,
                          and trustees holding charitable assets{' '}
                        </strong>{' '}
                        that are required to register with the California
                        Attorney General generally must file RRF-1 annually,
                        regardless of whether they file a federal Form 990.
                      </span>
                    </li>

                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          Does RRF-1 Replace Form 990? No.
                        </strong>{' '}
                        Form RRF-1 is a{' '}
                        <strong style={{ fontWeight: 600 }}>
                          California charitable registration filing{' '}
                        </strong>
                        and does not replace an organization's applicable
                        federal{' '}
                        <Link
                          href="https://www.taxzerone.com/tax-exempt/e-file-irs-form-990/"
                          sx={{
                            color: '#0202ff',
                            textDecoration: 'underline',
                          }}
                        >
                          Form 990
                        </Link>{' '}
                        <Link
                          href="https://www.taxzerone.com/resources/tax-exempt/form-990-ez-instructions/"
                          sx={{
                            color: '#0202ff',
                            textDecoration: 'underline',
                          }}
                        >
                          990-EZ
                        </Link>{' '}
                        or{' '}
                        <Link
                          href="https://www.taxzerone.com/resources/tax-exempt/form-990-pf-instructions/"
                          sx={{
                            color: '#0202ff',
                            textDecoration: 'underline',
                          }}
                        >
                          990-PF
                        </Link>{' '}
                        filing.
                      </span>
                    </li>

                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          Filing Deadline:{' '}
                        </strong>
                        Form RRF-1 is generally due{' '}
                        <strong style={{ fontWeight: 600 }}>
                          4 months and 15 days after the organization's
                          accounting period ends;{' '}
                        </strong>
                        for a calendar-year organization, this is{' '}
                        <strong style={{ fontWeight: 600 }}>May 15. </strong>
                      </span>
                    </li>
                  </Box>

                  <div
                    itemProp="publisher"
                    itemScope
                    itemType="https://schema.org/Organization"
                    style={{ display: 'none' }}
                  >
                    <span itemProp="name">TaxZerone</span>

                    <div
                      itemProp="logo"
                      itemScope
                      itemType="https://schema.org/ImageObject"
                    >
                      <link
                        itemProp="url"
                        href="https://www.taxzerone.com/assets/images/logo.webp"
                      />
                      <data itemProp="width" value="380" />
                      <data itemProp="height" value="124" />
                    </div>
                  </div>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    RRF-1 (Registration Renewal Fee Report)
                  </span>{' '}
                  is an annual filing requirement mandated by the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    California Attorney General’s Registry of Charitable Trusts
                  </span>
                  . It is used to monitor the financial transparency of
                  charitable organizations operating in California and ensure
                  that charitable funds are properly managed.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This form is typically filed alongside IRS filings such as
                  <Link
                    href="/tax-exempt/e-file-irs-form-990/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 990
                  </Link>
                  ,{' '}
                  <Link
                    href="/tax-exempt/e-file-irs-form-990-ez/"
                    sx={{ color: '#0202ff' }}
                  >
                    990-EZ
                  </Link>
                  ,{' '}
                  <Link
                    href="/tax-exempt/e-file-irs-form-990-pf/"
                    sx={{ color: '#0202ff' }}
                  >
                    990-PF
                  </Link>
                  , or <span style={{ fontWeight: 600 }}> Form 1120</span>.
                </Typography>
                <Box
                  component="div"
                  sx={{
                    mb: 5,
                    p: 2,
                    borderRadius: 2,
                    backgroundColor: '#f9f9f9',
                    backgroundSize: {
                      xs: '20% auto',
                      sm: '20% auto',
                      md: '20% auto',
                    },
                    border: '1px solid #ccc',
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    flexDirection: { xs: 'column', md: 'row' },
                  }}
                  // className="wave-bg"
                >
                  <Box
                    sx={{ width: '100%', flexGrow: 1, mb: { xs: 1, md: 0 } }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 600,
                        mb: 0,
                        fontSize: '22px !important',
                      }}
                    >
                      ðŸ“Œ Purpose in simple terms:
                    </Typography>
                    <Typography variant="body1">
                      It helps the state verify that nonprofit organizations are
                      operating legally and using funds for legitimate
                      charitable purposes.
                    </Typography>
                  </Box>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  Who is Required to File Form RRF-1?
                </Typography>
                <Typography variant="body1">
                  Organizations required to file Form RRF-1 include:
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }} component="ul">
                  <li style={{ marginBottom: 8 }}>
                    Nonprofit corporations registered in California
                  </li>
                  <li style={{ marginBottom: 8 }}>
                    Unincorporated charitable associations
                  </li>
                  <li>Trustees holding charitable or public benefit assets</li>
                </Typography>
                <Typography variant="body1">
                  Any organization registered with the{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    California Attorney General’s Registry of Charitable
                    Trusts{' '}
                  </span>{' '}
                  must generally file this report annually, even if:
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>No IRS Form 990 is required for the year</li>
                  <li>A federal filing extension has been granted</li>
                </Box>
                <Alert
                  severity="info"
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                  icon={<NewReleasesIcon />}
                >
                  <strong style={{ fontWeight: 600 }}> Important:</strong> Even
                  if no IRS Form 990 is required or a federal extension is
                  filed,{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    RRF-1 is still mandatory
                  </span>
                  .
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  Who is Exempt from Filing RRF-1?
                </Typography>
                <Typography variant="body1">
                  The following types of organizations are generally exempt:
                </Typography>
                <Box component="ul" sx={{ mb: 4, '& li': { mb: 1.2 } }}>
                  <li>Government agencies</li>
                  <li>Religious corporations sole</li>
                  <li>Certain cemetery corporations </li>
                  <li>
                    Political committees registered with the California
                    Secretary of State{' '}
                  </li>
                  <li>Licensed hospitals and educational institutions </li>
                  <li>
                    Health care service plans regulated by state
                    authorities{' '}
                  </li>
                  <li>
                    Certain federally or state regulated trustees (financial
                    institutions, custodians){' '}
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  When to File Form RRF-1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Form RRF-1 must be filed{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    no later than four months and fifteen days
                  </span>{' '}
                  after the end of the organization's accounting period.
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 2, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <strong style={{ fontWeight: 600 }}>Note:</strong>{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    For calendar-year organizations
                  </span>
                  , your RRF-1 filing is due by{' '}
                  <span style={{ fontWeight: 600 }}> May 15</span> of the
                  following year
                </Alert>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  If a federal extension is filed for Form 990, 990-EZ, 990-PF,
                  or 1120, the RRF-1 may be filed after the extension period
                  once the federal return is completed. Supporting extension
                  documentation should be included when filing under an
                  extension timeline.
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  What You Need to File
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Required submissions include a complete copy of your accepted
                  federal return (Form 990, 990-EZ, 990-PF, or{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f1120.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120
                  </Link>
                  ), along with all supporting schedules and attachments, except
                  Schedule B (as applicable). Organizations with gross receipts
                  under $50,000 that{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_990N_SITE_URL}?ref=rrf1`}
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    file IRS Form 990-N (e-Postcard)
                  </Link>{' '}
                  must complete and attach{' '}
                  <Link
                    href="https://oag.ca.gov/system/files/media/ct-tr1-form.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form CT-TR-1
                  </Link>
                  .
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <strong style={{ fontWeight: 600 }}>Note:</strong> All
                  required attachments must be submitted together. Missing
                  documents or incomplete filings may result in delays or
                  compliance issues with the California Attorney General’s
                  office.
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  Annual Registration Renewal Fee Structure
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  The registration renewal fee must be included with your Form
                  RRF 1. The amount is based on total revenue for the previous
                  fiscal year, as reported on your Form 990, 990-EZ, 990-PF,
                  1120, or CT-TR-1.{' '}
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer
                    sx={{ border: '1px solid #828282', borderRadius: 2 }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              borderRight: '1px solid #828282',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Total Revenue
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Fee
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Less than $50,000
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            $25
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $50,000 and $100,000
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            $50
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $100,001 and $250,000
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            $75
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $250,001 and $1 million
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            $100
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $1,000,001 and $5 million
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            $200
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $5,000,001 and $20 million
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            $400
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $20,000,001 and $100 million
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            $800
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Between $100,000,001 and $500 million
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            $1,000
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Greater than $500 million
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            $1,200
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Alert
                  severity="warning"
                  icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <strong style={{ fontWeight: 600 }}>Note:</strong> You do not
                  need to pay a registration fee again when submitting an
                  amended report for a period when you’ve already paid the fee,
                  unless the amended report changes the fee amount.
                </Alert>

                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    mb: 0.8,
                    fontSize: { md: 23, sm: 18, xs: 16 },
                  }}
                >
                  Form RRF-1 Payment Methods
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer
                    sx={{ border: '1px solid #828282', borderRadius: 2 }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              borderRight: '1px solid #828282',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Method
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Details
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            ACH (Bank Transfer)
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            No additional fee
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Credit Card
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            2.3% processing fee
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Check / Money Order
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Payable to “Department of Justice”
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  Form RRF-1 Filing
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  Form RRF-1 can be submitted either online or by mail.{' '}
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer
                    sx={{ border: '1px solid #828282', borderRadius: 2 }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              borderRight: '1px solid #828282',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Filing Methods
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              borderRight: '1px solid #828282',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Online Portal
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Mailing Address
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'left',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            <ul>
                              <li>
                                Online filing (eligible organizations only)
                              </li>
                              <li>Paper filing via mail </li>
                              <li>Amendment filings via paper/email</li>
                            </ul>
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            <Link
                              href="https://rct.doj.ca.gov/eGov/Login.aspx"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Charity Registration Online Renewal System{' '}
                            </Link>
                          </TableCell>
                          <TableCell sx={{ textAlign: 'center' }}>
                            Registry of Charities and <br /> Fundraisers P.O.
                            Box 903447
                            <br /> Sacramento, CA 94203-4470
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert
                  severity="warning"
                  // icon={false}
                  sx={{ mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                >
                  <strong style={{ fontWeight: 600 }}>Caution:</strong> Online
                  filing is not available for: <br />
                  <ul>
                    <li>Initial registrations</li>
                    <li>Raffle filings </li>
                    <li>Certain amendments </li>
                    <li>
                      Amended filings (must be submitted by mail or email){' '}
                    </li>
                  </ul>
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                >
                  Penalties for Non-Compliance
                </Typography>

                <Typography variant="body1" sx={{ mt: 1 }}>
                  Failure to comply with filing requirements can lead to serious
                  consequences.
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mt: 1 }}>
                  Penalty Summary Table
                </Typography>
                <Box component="div" sx={{ mb: 3 }}>
                  <TableContainer
                    sx={{ border: '1px solid #828282', borderRadius: 2 }}
                  >
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow sx={{ backgroundColor: '#ccc' }}>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              borderRight: '1px solid #828282',
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Violation
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 200,
                              textAlign: 'center',
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Late filing
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            Penalties + interest
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Non-filing
                          </TableCell>

                          <TableCell sx={{ textAlign: 'center' }}>
                            Minimum $800 penalty
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell
                            sx={{
                              textAlign: 'center',
                              borderRight: '1px solid #828282',
                            }}
                          >
                            Continued failure
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'center',
                            }}
                          >
                            Possible loss of tax exemption
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert
                  severity="info"
                  sx={{ mb: 4, borderLeft: '3px solid #0288d1' }}
                  icon={<NewReleasesIcon />}
                >
                  <strong style={{ fontWeight: 600 }}> Important:</strong>
                  <ul>
                    <li>RRF-1 is separate from IRS filings </li>
                    <li>Both federal and state compliance are required </li>
                    <li>
                      Filing is mandatory for maintaining California charity
                      registration{' '}
                    </li>
                  </ul>
                </Alert>

                <Alert severity="info" icon={false} sx={{ borderRadius: 2 }}>
                  <Accordion
                    defaultExpanded
                    sx={{
                      '&.MuiAccordion-root::before, &.MuiAccordion-root.Mui-expanded::before':
                        {
                          background: 'none !important',
                        },
                      '&.MuiAccordion-root': { background: 'none !important' },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls=""
                      sx={{
                        px: 0,
                        m: 0,
                        justifyContent: 'flex-start',
                        '& .MuiAccordionSummary-content, & .MuiAccordionSummary-content.Mui-expanded':
                          { m: '0 !important', flexGrow: 0 },
                      }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          color: '#014361',
                          fontSize: 16,
                        }}
                      >
                        Sources and References
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 0 }}>
                      <Typography
                        component="div"
                        variant="body2"
                        sx={{ mt: 1 }}
                      >
                        This information is based on guidance provided by the
                        California Department of Justice, Registry of Charities
                        and Fundraisers. For complete filing requirements,
                        renewal fees, deadlines, reporting obligations, and
                        online filing procedures, refer to the official{' '}
                        <Link
                          href="https://oag.ca.gov/system/files/media/rrf1_form.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Form RRF-1 (Annual Registration Renewal Fee Report)
                        </Link>{' '}
                        and the{' '}
                        <Link
                          href="https://oag.ca.gov/system/files/media/online-renewal-checklist.pdf"
                          target="_blank"
                          sx={{ color: '#0202ff' }}
                        >
                          Online Renewal System Checklist
                        </Link>{' '}
                        .
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                </Alert>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {/* <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Ready to Take the Next Step?
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 2,
              }}
            >
              Ensure your nonprofit&apos;s success with the right filing choice.
              <br />
              TaxZerone is here to help you navigate{' '}
              <span style={{ fontWeight: 600 }}> Form 990</span> or{' '}
              <span style={{ fontWeight: 600 }}>Form 990-EZ</span> process with
              ease.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=990vs990EZ`}
              >
                E-file Now!
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container> */}
    </AppLayout>
  );
};

export default CaliforniaFormRRF;
